module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "roleList"
  }, [_c('el-card', {
    staticClass: "box-card fl",
    staticStyle: {
      "width": "35%",
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header fl"
  }, [_vm._v("角色信息")]), _vm._v(" "), (_vm.basicsAuth.roleAdd) ? _c('el-button', {
    staticClass: "fr",
    attrs: {
      "size": "mini",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.AddMenuForm()
      }
    }
  }, [_vm._v("新增")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "data": _vm.roleInfo,
      "highlight-current-row": "",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "row-click": _vm.openDetails
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "roleName",
      "label": "角色名称",
      "width": "150",
      "align": "center",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("\n                更多操作"), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [(_vm.basicsAuth.roleEdit) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.EditRole(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.roleDel) ? _c('el-dropdown-item', {
          nativeOn: {
            "click": function($event) {
              return _vm.DelRole(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogStatus],
      "visible": _vm.dialogRoleEdit,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogRoleEdit = $event
      },
      "close": _vm.emptyDialog
    }
  }, [_c('el-form', {
    ref: "editRole",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.editRole,
      "label-width": "100px",
      "rules": _vm.editRoleRules
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "角色名称:",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editRole.roleName),
      callback: function($$v) {
        _vm.$set(_vm.editRole, "roleName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editRole.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editRole.memo),
      callback: function($$v) {
        _vm.$set(_vm.editRole, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editRole.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogStatus == 'create') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createData('editRole')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateData('editRole')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogRoleEdit = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改信息",
      "visible": _vm.dislogChangeQuery,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogChangeQuery = $event
      }
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("基本信息")])]), _vm._v(" "), _c('el-form', {
    ref: "queryForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.queryForm,
      "label-width": "100px",
      "rules": _vm.queryFormRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "fl",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "所属角色",
      "prop": "role_name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.queryForm.role_name),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "role_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryForm.role_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr",
    staticStyle: {
      "width": "48%"
    },
    attrs: {
      "label": "是否为全局授权",
      "prop": "query_agree"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择活动区域"
    },
    model: {
      value: (_vm.queryForm.query_agree),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "query_agree", $$v)
      },
      expression: "queryForm.query_agree"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": "yes"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": "no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入描述信息"
    },
    model: {
      value: (_vm.queryForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "remarks", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryForm.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header"
  }, [_vm._v("数据范围")])]), _vm._v(" "), _c('el-form', {
    ref: "queryForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.queryForm,
      "label-width": "100px",
      "rules": _vm.queryFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设置数据范围（数据范围为空，表示数据范围为登录者本部门）",
      "prop": "query_range"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": true
    },
    model: {
      value: (_vm.queryForm.query_range),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "query_range", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryForm.query_range"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.basicsAuth.roleAuth) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updataChangeQuery()
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dislogChangeQuery = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "60%"
    }
  }, [_c('div', {
    staticClass: "clearfix header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header fl"
  }, [_vm._v("功能权限")])]), _vm._v(" "), _c('ul', {
    staticClass: "role-table row"
  }, [_c('li', {
    staticClass: "header2"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "width": "30%",
      "text-align": "center"
    }
  }, [_vm._v("模块名称")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    staticStyle: {
      "width": "70%",
      "text-align": "center"
    }
  }, [_vm._v("权限名称")])]), _vm._v(" "), (_vm.testLists.length === 0) ? _c('li', {
    staticStyle: {
      "border-bottom": "1px solid #e0e0e0",
      "text-align": "center",
      "line-height": "40px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.testLists), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "left h40",
      staticStyle: {
        "width": "30%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.menuName))]), _vm._v(" "), _c('div', {
      staticClass: "right h40",
      staticStyle: {
        "width": "70%",
        "text-align": "center"
      }
    }, [_c('el-checkbox-group', {
      model: {
        value: (_vm.checkList),
        callback: function($$v) {
          _vm.checkList = $$v
        },
        expression: "checkList"
      }
    }, _vm._l((item.children), function(m) {
      return _c('el-checkbox', {
        key: m.id,
        attrs: {
          "label": m.autId
        }
      }, [_vm._v(" " + _vm._s(m.autName))])
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.testLists.length !== 0),
      expression: "testLists.length !== 0"
    }],
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin": "20px auto",
      "display": "block"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveRoleAuth()
      }
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-996fdba8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/systemSet/roleList.vue
// module id = 1726
// module chunks = 0